/* eslint-disable max-len */
import styled from 'styled-components'
import colors from 'globals/colors'
import measures from 'globals/measures'

interface SelectWrapperProps {
  hasError: boolean,
  noBottomPadding?: boolean,
  nbPerLine: number
}

export const SelectWrapper = styled.div<SelectWrapperProps>`
  max-width: 100%;
  flex-basis: calc(${(props) => 100 / props.nbPerLine}% - ${(props) => 5 * (props.nbPerLine - 1)}px);
  
  & .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: 40px;
  }
  
  & .ant-select-single:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-search-input {
    height: 38px;
  }
  
  & .ant-select-single .ant-select-selector .ant-select-selection-item, .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
    line-height: 38px;
  }
  
  ${(props) => !props.noBottomPadding && `
    padding-bottom: 17px;
  `};
  
  ${(props) => props.hasError && `
    & .ant-select-selection {
      border-color: ${colors.reddishPink};
    }
    
    & .ant-select-arrow {
      color: ${colors.reddishPink};
    }
  `};
  
  @media (max-width: ${measures.mobileThreshold}px) {
    ${(props) => props.nbPerLine && `
      flex-basis: 100%;
    `};
    
    padding-right: 0;
  }
  
  & > .ant-select {
    width: 100%;
    
    &.ant-select-open > .ant-select-selection {
      border-radius: 4px 4px 0 0;
    }
  }
`

export const SelectLabel = styled.div`
  line-height: 19px;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 11px;
`

export const Required = styled.span `
  color: ${colors.waterBlue};
`
